export default __webpack_public_path__ + "static/media/checkIcon.d1782b30.svg";